import template from './spinner.html'
import './spinner.styl'

let component = {
  restrict: 'E',
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/spinner/spinner.component.js